import { RouteObject } from 'react-router-dom'
import { SystemRoles } from '../providers/roles'
import { _Subscriptions } from '../providers/subscriptions'
import { AdminRoutes } from './admin'
// import { BrandAdminRoutesFREE } from './brandAdminFREE'
// import { BrandAdminRoutesUGC } from './brandAdminUGC'
// import { BrandAdminRoutesXGC } from './brandAdminXGC'
import { BrandAdminRoutesTDC } from './brandAdminTDC'
// import { BrandMemberRoutesFREE } from './brandMemberFREE'
// import { BrandMemberRoutesUGC } from './brandMemberUGC'
// import { BrandMemberRoutesXGC } from './brandMemberXGC'
import { BrandMemberRoutesTDC } from './brandMemberTDC'
//import { ProTeamAdminRoutes } from './proTeamAdmin'
import { ProRoutes } from './pro'
import { InternalRoutes } from './internalRoutes'
import { BrandSalesRoutes } from './brandSales'
import { BrandRootRoutes } from './brandRoot'
//import { SalesTeamRoutes } from './salesTeam'
//import { AccountManagerAdminRoutes } from './accountManagerAdmin'
//import { PostProductionAdminRoutes } from './postProductionAdmin'

// The role's own page tree. For the three brand roles this is the BRAND PAGE
// SET, which since TDC-1609 is mounted under /portal/:brandSlug rather than at
// the root — see generateRoutes below and router/portalRoutes.tsx.
export const roleRouteTree = (role: keyof typeof SystemRoles | null, subscription: keyof typeof _Subscriptions | null) => {
  const roleRoutesMap: any = {
    ADMIN: AdminRoutes,
    PRO: ProRoutes,
    BRAND_MEMBER: {
      // null: BrandMemberRoutesFREE,
      // UGC: BrandMemberRoutesUGC,
      // XGC: BrandMemberRoutesXGC,
      TDC: BrandMemberRoutesTDC,
    },
    BRAND_ADMIN: {
      // null: BrandAdminRoutesFREE,
      // UGC: BrandAdminRoutesUGC,
      // XGC: BrandAdminRoutesXGC,
      TDC: BrandAdminRoutesTDC,
    },
    PRO_TEAM_ADMIN: InternalRoutes,
    SALES_TEAM: InternalRoutes,
    ACCOUNT_MANAGER_ADMIN: InternalRoutes,
    POST_PRODUCTION_ADMIN: InternalRoutes,
    BRAND_TEAM_SALES: BrandSalesRoutes,
  }
  if (!role) return []

  let roleRoutes
  switch (role) {
    case 'ADMIN':
    case 'PRO_TEAM_ADMIN':
    case 'PRO':
    case 'SALES_TEAM':
    case 'ACCOUNT_MANAGER_ADMIN':
    case 'POST_PRODUCTION_ADMIN':
    // BRAND_TEAM_SALES is NOT subscription-indexed — falling through to the
    // default branch would crash on roleRoutesMap[role][subscription].
    case 'BRAND_TEAM_SALES':
        roleRoutes = roleRoutesMap[role]
        break
    case 'BRAND_ADMIN':
    case 'BRAND_MEMBER':
    default: {
      // A role absent from the map used to index
      // into `undefined` and throw a TypeError mid-render, which the root
      // errorElement reported as a 404. An empty route set renders nothing,
      // which is wrong but legible; a crash disguised as a 404 is neither.
      const table = roleRoutesMap[role]
      roleRoutes = table ? table[String(subscription)] : undefined
      break
    }
  }

  if (!roleRoutes) return []
  return [...roleRoutes]
}

// What <Home/> mounts at the root.
//
// Brand clients get the small brandRoot tree instead of their page set: their
// pages are canonically slugged now, so the root only keeps what genuinely
// belongs there (the personal settings tabs, tutorials) plus the entry
// redirect and the permanent slug-free -> slugged shim. Every other role is
// untouched.
export const generateRoutes = (
  role: keyof typeof SystemRoles | null,
  subscription: keyof typeof _Subscriptions | null,
) => {
  if (role === 'BRAND_ADMIN' || role === 'BRAND_MEMBER' || role === 'BRAND_TEAM_SALES') {
    return [...BrandRootRoutes]
  }
  return roleRouteTree(role, subscription)
}
